import { Link as ReachLink, useLocation } from 'react-router-dom';
import { IconType } from 'react-icons/lib';
import { useSideNav } from '@/hooks/useSideNav';
import { SideSubMenu } from '@/components/SideSubMenu';
import { LinkText, MenuIcon, MenuItem, MenuLink } from './styles';
import { Flex, Tooltip } from '@chakra-ui/react';


export type MenuItemProps = {
  title: string;
  to: string;
  icon: IconType;
  setIsOpen: VoidFunction,
  isOpen: boolean;
  childrens?: Array<{
    title: string;
    to?: string;
    childrens?: Array<{
      title: string;
      to: string;
    }>;
  }>;
};

export function SideMenuItem({ title, to, icon, childrens, setIsOpen, isOpen }: MenuItemProps) {
  const { open } = useSideNav();
  const { pathname } = useLocation();

  const active = pathname.includes(to);

  return (
    <>
      <Tooltip label={title} placement='right' isDisabled={open}>
        <MenuItem className={active ? 'active' : ''}>
          <MenuLink justifyContent={active ? 'center' : 'space-between'} as={title?.toLowerCase().match('logout') ? ReachLink : undefined} to={to} onClick={setIsOpen}>
            <Flex alignItems={'center'}>
              <MenuIcon as={icon} fontSize={'lg'} />
              <LinkText className={open ? '' : 'collapsed'}>
                <span>{title}</span>
              </LinkText>
            </Flex>
          </MenuLink>
          {childrens && isOpen && <SideSubMenu open={isOpen && open} items={childrens} />}
        </MenuItem>
      </Tooltip>
    </>
  );
}
